import React from 'react';

import Link from '../../../../library/link/link';
import Typography from '../../../../library/typography/typography';
import { TreadwellTireRegularIcon } from '../../../../shared/icons/icons';

import './tire-comparison-table.scss';

interface TireComparisonTableProps {
  currentDistance: number;
  currentProductLabel?: string;
  currentRank: number;
  currentWornDistance?: number;
  hideRecommended?: boolean;
  isDry?: boolean;
  recommendedDistance: number;
  recommendedProductLabel: string;
  recommendedProductUrl: string;
  recommendedRank: number;
  recommendedWornDistance?: number;
}

function TireComparisonTable(props: TireComparisonTableProps) {
  const {
    currentDistance = 0,
    currentProductLabel = '',
    currentRank = '',
    currentWornDistance = 0,
    hideRecommended = false,
    isDry = false,
    recommendedDistance = 0,
    recommendedProductLabel = '',
    recommendedProductUrl = '',
    recommendedRank = 0,
    recommendedWornDistance = 0
  } = props;

  const currentLabel = currentProductLabel || 'Current Tire';
  const recommendedLabel = recommendedProductLabel || 'Recommended Tire';

  return (
    <div styleName="container">
      <div styleName="tire">
        <div styleName={hideRecommended ? 'label-only' : 'label'}>
          {!hideRecommended && (
            <>
              <TreadwellTireRegularIcon styleName="icon" />
              <span>#{currentRank}</span>
            </>
          )}
          <Typography size="extraSmall">{currentLabel}</Typography>
        </div>
        <div styleName="distance">
          {isDry ? (
            <div styleName="breakdown-dry">
              <span styleName="dry-pill" />
              <span styleName="value">
                <strong>{Math.floor(currentDistance)} ft.</strong>
              </span>
            </div>
          ) : (
            <>
              <div styleName="breakdown">
                <span styleName="wet-pill" />
                <span styleName="value">
                  New tread: <strong>{Math.floor(currentDistance)} ft.</strong>
                </span>
              </div>
              <div styleName="breakdown">
                <span styleName="wet-worn-pill" />
                <span styleName="value">
                  Worn tread:{' '}
                  <strong>{Math.floor(currentWornDistance)} ft.</strong>
                </span>
              </div>
            </>
          )}
        </div>
      </div>

      {!hideRecommended && (
        <div styleName={isDry ? 'tire-dry' : 'tire'}>
          <div styleName="label">
            <TreadwellTireRegularIcon styleName="icon" />
            <span>#{recommendedRank}</span>
            <span>
              {recommendedProductUrl ? (
                <Link size="extraSmall" to={recommendedProductUrl}>
                  {recommendedLabel}
                </Link>
              ) : (
                <span>{recommendedLabel}</span>
              )}
            </span>
          </div>
          <div>
            {isDry ? (
              <div styleName="breakdown-dry">
                <span styleName="recommended-pill" />
                <span styleName="value">
                  <strong>{Math.floor(recommendedDistance)} ft.</strong>
                </span>
              </div>
            ) : (
              <>
                <div styleName="breakdown">
                  <span styleName="recommended-pill" />
                  <span styleName="value">
                    New tread:{' '}
                    <strong>{Math.floor(recommendedDistance)} ft.</strong>
                  </span>
                </div>
                <div styleName="breakdown">
                  <span styleName="recommended-worn-pill" />
                  <span styleName="value">
                    Worn tread:{' '}
                    <strong>{Math.floor(recommendedWornDistance)} ft.</strong>
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default TireComparisonTable;
